import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraphStatsSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "graph-stats-square" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: .75,
			width: 22.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M3.75,12.75h3L9.01,7.1a.749.749,0,0,1,1.4.029l3.292,9.325a.75.75,0,0,0,1.358.123L17.25,12.75h3"
		})
	]
});
export default SvgGraphStatsSquare;
